import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Section from "./Section";
import Sectionfour from "./Sectionfour";
import "./about.scss";

function About() {
  useEffect(() => {    
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="About">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/laboratory/about-ggi-laboratory"
        />
                    <title>About Ggi Laboratory's Vision | Galaxy Gemological Institute</title>
            <meta name="description" content="Lorem ipsum dolor sit amet" />

      </Helmet>
      <Sectionfour />
      <Section />
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(About);
